import type { TaskFieldModuleDefinition } from './types'
import type { TaskFormFieldDefinition } from './types'

const registry = new Map<string, TaskFieldModuleDefinition>()

export function registerModule(def: TaskFieldModuleDefinition): void {
  registry.set(def.moduleKey, def)
}

export function getModule(moduleKey: string): TaskFieldModuleDefinition | undefined {
  return registry.get(moduleKey)
}

/** Resolve built-in or admin-created embed modules (custom.* with URL config). */
export function resolveModuleForField(field: TaskFormFieldDefinition): TaskFieldModuleDefinition | undefined {
  const direct = getModule(field.module)
  if (direct) return direct

  const config = field.config ?? {}
  const hasUrl = Boolean(config.url ?? config.urlTemplate)
  if (!hasUrl) return undefined

  if (field.module.startsWith('custom.') || field.module.startsWith('embed.')) {
    if (config.urlTemplate && !config.url) {
      return getModule('embed.external_link_panel')
    }
    return getModule('embed.iframe')
  }

  return undefined
}
export function listRegisteredModules(): TaskFieldModuleDefinition[] {
  return Array.from(registry.values())
}

export function mergeCatalogWithRegistry(
  catalog: Array<{ module_key: string; label: string; category: string; badge?: string | null }>
): Array<{ module_key: string; label: string; category: string; badge?: string }> {
  const fromRegistry: Array<{ module_key: string; label: string; category: string; badge?: string }> =
    listRegisteredModules().map((m) => ({    module_key: m.moduleKey,
    label: m.label,
    category: m.category,
    badge: m.badge,
  }))
  const keys = new Set(fromRegistry.map((m) => m.module_key))
  const merged = [...fromRegistry]
  for (const row of catalog) {
    if (!keys.has(row.module_key)) {
      merged.push({
        module_key: row.module_key,
        label: row.label,
        category: row.category,
        badge: row.badge ?? undefined,
      })
    }
  }
  return merged
}
